import { datadogRum } from '@datadog/browser-rum'
import config from 'config'

export const initDatadog = () => {
  datadogRum.init({
    applicationId: config.NEXT_PUBLIC_DD_APP_ID,
    env: config.NEXT_PUBLIC_YD_STAGE,
    site: 'datadoghq.com',
    clientToken: config.NEXT_PUBLIC_DD_CLIENT_TOKEN,
    service: config.NEXT_PUBLIC_DD_SERVICE,
    version: config.NEXT_PUBLIC_DD_VERSION,
    sessionSampleRate: Number(config.NEXT_PUBLIC_DD_SAMPLE_RATE),
    sessionReplaySampleRate: Number(config.NEXT_PUBLIC_DD_PREMIUM_RATE),
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    // v7 flipped the default to true, which adds a `baggage` header to every
    // request matching allowedTracingUrls — all four are cross-origin, so CORS
    // preflights would fail until each service allowlists that header.
    propagateTraceBaggage: false,
    allowedTracingUrls: [
      url =>
        !!config.NEXT_PUBLIC_API_URL &&
        url.startsWith(config.NEXT_PUBLIC_API_URL),
      url =>
        !!config.NEXT_PUBLIC_GALACTUS_URL &&
        url.startsWith(config.NEXT_PUBLIC_GALACTUS_URL),
      url =>
        !!config.NEXT_PUBLIC_YD_ATTACHMENT_URL &&
        url.startsWith(config.NEXT_PUBLIC_YD_ATTACHMENT_URL),
      url =>
        !!config.NEXT_PUBLIC_UNFURL_SERVICE_URL &&
        url.startsWith(config.NEXT_PUBLIC_UNFURL_SERVICE_URL)
    ]
  })

  datadogRum.startSessionReplayRecording()
}
